import { render, staticRenderFns } from "./DeliveryAddressInput.vue?vue&type=template&id=8ec35010&scoped=true&lang=pug&"
import script from "./DeliveryAddressInput.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddressInput.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAddressInput.vue?vue&type=style&index=0&id=8ec35010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec35010",
  null
  
)

export default component.exports